// Content.js
import React from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import JobOpening from "../Pages/JobOpening";
import PageOpening from "../Pages/PageOpening";
import Login from "../../Auth/Login";
import SignUp from "../../Auth/SignUp";
import VerifyEmail from "../../Auth/VerifyEmail";
import ResetPassword from "../Pages/forgot-password/ResetPassword";
import ResetPasswordMessage from "../Pages/forgot-password/ResetPasswordMessage";

const Content = (props) => {
  const location = useLocation();

  const hideLoginModalPaths = ["/reset-password", "/reset-your-password"];
  const normalizedPath = location.pathname.replace(/\/+$/, "");

  const shouldShowLoginModal = !hideLoginModalPaths.includes(normalizedPath);

  return (
    <>
      <Routes>
        {/* <Route path="/" element={<JobOpening />} />
        <Route path={`/:title`} element={<PageOpening />} /> */}
        <Route path={`/reset-password`} element={<ResetPassword />} />
        <Route path={`/reset-your-password`} element={<ResetPasswordMessage />} />
      </Routes>

      {shouldShowLoginModal && <Login loginHandler={props.loginHandler} />}
      <SignUp loginHandler={props.loginHandler} />
      <VerifyEmail />
    </>
  );
};

export default Content;
